<template>
  <main-header :is-dark="$versions?.homePage === '5' || $versions?.quiz === '7'" />
  <HomePageV1 class="sensitive_content" />
</template>

<script setup lang="ts">
import { useFacebookPixel } from '@/composables/facebookPixel.ts';
import HomePageV1 from '~/components/homePage/HomePageV1.vue';

const { $versions, $ttTrack } = useNuxtApp();
const { mixpanelQuizTrack } = useMixpanel();
const { fbqTrack } = useFacebookPixel();
const { locale } = useI18n();
const firstMount = ref(true);
useJsonld([
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': ': for Men\'s Health',
    'url': 'https://quiz.kegel-plan.com/',
    'logo': 'https://quiz.kegel-plan.com/images/logos/logo_white.webp',
    'sameAs': ['https://www.facebook.com/drkegelformenshealth'],
    'contactPoint': {
      '@type': 'ContactPoint',
      'contactType': 'Customer Support',
      'email': 'support@appercut.eu',
    },
    'email': 'support@appercut.eu',
    'description': 'The  app provides men with 6 exceptional features that form a comprehensive solution for improving intimate, overall & mental health.',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Product',
    'name': ': for Men\'s Health',
    'description': ' is an innovative app that provides a complex approach to strengthen male intimate health',
    'image': 'https://quiz.kegel-plan.com/images/img_beforeafter.webp',
    'brand': {
      '@type': 'Brand',
      'name': '',
    },
    'offers': {
      '@type': 'Offer',
      'price': '15.19',
      'priceCurrency': 'USD',
      'url': 'https://quiz.kegel-plan.com/',
    },
    'aggregateRating': {
      '@type': 'AggregateRating',
      'ratingValue': '4.8',
      'reviewCount': '28000',
    },
    'review': {
      '@type': 'Review',
      'author': {
        '@type': 'Person',
        'name': 'JackSUN.X0X367',
      },
      'reviewRating': {
        '@type': 'Rating',
        'ratingValue': '5',
        'bestRating': '5',
      },
      'reviewBody': 'It\'s been only a couple of weeks with exercises but I can already see a huge difference in my performance. I\'m happy with my results!',
    },
  },
]);

fbqTrack('PageView');

if (import.meta.client) {
  $ttTrack('ViewContent');
}

onMounted(() => {
  if (!import.meta.client || !firstMount.value) {
    return;
  }

  setTimeout(() => {
    window.scrollTo(0, 1);
  }, 400);

  nextTick(() => {
    mixpanelQuizTrack(
      'Start Screen Shown',
      {
        Quiz_version: $versions?.value.quiz,
        Version: $versions?.value.homePage,
        Landing_version: $versions?.value.landing,
        Locale: locale.value?.toUpperCase(),
      },
    );
    firstMount.value = false;
  });
});

definePageMeta({
  layout: 'start-layout',
});
</script>
